interface DropdownLabelProps {
  children: React.ReactNode
  className?: string
}

export default function DropdownLabel({
 children, className = '' 
}: DropdownLabelProps) {
  return (
    <span className={`text-sm font-medium text-gray-900 ${className}`}>
      {children}
    </span>
  )
} 